<template>
    <div class="standBook">
        <!-- 润滑点台账 -->
        <div class="btn" v-if="['m0','m1','c1'].indexOf(userRole)>-1">
            <template v-if="groupAuthorityString!=='r'">
            <Button type="primary" @click="accountClick()">手动录入台账</Button>
            </template>
            <Button style="margin-left:16px" @click="ruleClick()">{{groupAuthorityString!=='r'?'设置自动台账规则':'查看自动台账规则'}}</Button>
            
        </div>
        <!-- 列表 -->
        <div class="list" v-if="isdisble">
            <div class="common-list">
                <Table class="equipmentTable" 
                :columns="dataColumn" :data="dataLists"></Table>
            </div>
            <div class="common-page fr">
                <Page show-total show-elevator show-sizer 
                :total="standBookTotal"
                 :current="standBookParams.page"
                  :page-size='standBookParams.limit
                  ' @on-change='getStandBookList' @on-page-size-change='getStandListsSize'>
                </Page>
            </div>
        </div>
        <div v-else style="height:200px" class="u-flex mw u-row-center">
            <Spin></Spin>
        </div>
        <!-- 手动录入台账 -->
        <Modal class="common-drawer newModal" class-name="constabook" v-model="enterIsshow" title="手动录入台账" width="480px" :mask-closable="false" @on-visible-change="e=>{closeaccount()}">
            <Form ref="accountFormValidate" :model="accountFromData" label-position="top" :rules="accuntRuleValidate">
                <FormItem prop="time" label="时间" required>
                    <DatePicker v-model="accountFromData.time" style="width:100%;" @on-change="changeDate" type="datetimerange" format="yyyy-MM-dd HH:mm" placeholder="请选择" :timePickerOptions="timePickerOption"></DatePicker>
                </FormItem>
                <FormItem label="状态" prop="statu">
                    <Select v-model="accountFromData.statu" :clearable="true" placeholder="请选择">
                        <Option :key="item.describe" :value="item.number" v-for="item in status">{{item.describe}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="描述">
                    <Input v-model="accountFromData.describeRule" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }" maxlength="200" show-word-limit placeholder="请输入"></Input>
                </FormItem>
            </Form>
            <div class="drawer-footer" slot="footer">
                <Button type="primary" @click="submitAccuntForm()" :loading="btnLoading">提交</Button>
                <Button style="margin-left: 8px" @click="closeDrawer('accountFrom')">取消</Button>
            </div>
        </Modal>
        <!-- 设置自动台账规则 -->
        <Drawer class="common-drawer" :title="groupAuthorityString!=='r'?'设置自动台账规则':'查看自动台账规则'" v-model="ruleIsshow" width="40%" :scrollable="true">
            <div  v-if="groupAuthorityString!=='r'">
                <Button type="primary" @click="addRuleClick">新增规则</Button>
            </div>
            <div class="common-list">
                <Table class="equipmentTable"
                 :columns="ruleList" :data="automaticRuleList"></Table>
            </div>
            <div class="common-page fr" style="margin-right:20px">
                <Page show-total show-elevator show-sizer :total="ruleListTotal" :current="ruleListParams.page" :page-size='ruleListParams.limit' @on-change='getRuleList' @on-page-size-change='getRuleListsSize'>
                </Page>
            </div>
        </Drawer>
        <!-- 新增规则 -->
        <Modal class="common-drawer newModal" v-model="addRuleIsshow" :title="RuleTitle" width="480px" :mask-closable="false" @on-visible-change="e=>{closeaccount()}">
            <div @click="changeCycle = 'day';cycleChanges=false">
                <Form ref="RuleFormValidate" :rules="RuleValidate" :model="addRuleFormData" label-position="top">
                    <div class="cycle">
                        <div class="label"><span class="star">*</span>周期</div>
                        <div class="select" :class="{'selection': cycleChanges,'borderRed':cyclerequired}" @click.stop="cycleChanges=!cycleChanges">
                            <span class="pla" v-if="addRuleFormData.cycle">{{ addRuleFormData.cycle }}</span>
                            <span class="pla gray" v-else>请选择</span>
                            <Icon class="icon" :type="cycleChanges?'ios-arrow-up':'ios-arrow-down'" />
                        </div>
                        <div class="option" v-if="cycleChanges">
                            <div class="item" :key="brand.describe" @click.self.stop="option(brand)" :value="brand.describe" v-for="brand in cycles">{{brand.describe}}</div>
                        </div>
                        <!-- 周 -->
                        <div v-if="changeCycle=='week'" class="time cycleDetail" @click.stop="changeCycle = 'week'">
                            <span :class="subitem.active == 1?'active':''" class="pot" v-for="subitem in cycles[1].statusList" :key="subitem.describe" @click.stop="cycleDetailClick(subitem)">{{subitem.describe}}</span>
                        </div>
                        <!-- 月 -->
                        <div v-if="changeCycle=='month'" class="time cycleDetails" @click.stop="changeCycle = 'month'">
                            <span class="pot" :class="subitem1.active == 1?'active words':'words'" v-for="subitem1 in cycles[2].statusList" :key="subitem1.describe" @click.stop="cycleDetailClick(subitem1)">{{subitem1.describe}}</span>
                        </div>
                        <div class="errorTip" v-if="cyclerequired">请选择周期</div>
                    </div>
                    <FormItem label="时间" prop="ruleTime" style="margin-top:26px;">
                        <TimePicker v-model="addRuleFormData.ruleTime" style="width:100%;" format="HH:mm" type="timerange" @on-change="ruleChangeDate" placement="bottom-start" placeholder="请选择" hide-disabled-options :disabled-minutes="disabledMinutes" ></TimePicker>
                    </FormItem>
                    <FormItem label="状态" prop="statu">
                        <Select v-model="addRuleFormData.statu" :clearable="true" placeholder="请选择">
                            <Option :key="item.describe" :value="item.number" v-for="item in status">{{item.describe}}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label="备注">
                        <Input v-model="addRuleFormData.describeRule" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }" maxlength="200" show-word-limit placeholder="请输入"></Input>
                    </FormItem>
                </Form>
            </div>
            <div class="drawer-footer" slot="footer">
                <Button type="primary" @click="submitRuleForm()" :loading="btnLoading">提交</Button>
                <Button style="margin-left: 8px" @click="closeDrawer('addRuleFrom')">取消</Button>
            </div>
        </Modal>
    </div>
</template>
  <script>
import api from "@/api";
import sizeData from "@/mixins/sizeData";
import handleSelItem from "@/mixins/handleSelItem";
import toRoleName from "@/mixins/roleName";
import ls from "store2";
  import Base64 from '@/util/encryptlong'

export default {
    props: ["getLists","groupAuthorityString"],
    mixins: [handleSelItem, sizeData, toRoleName],
    data() {
        return {
            isdisble: false,
            power: false,
            cycleChanges: false,
            userInfo: JSON.parse(Base64.decode(ls.page("userInfo"))) || {},
            userRole: null,
            enterIsshow: false,
            ruleIsshow: false,
            addRuleIsshow: false,
            changeCycle: "day",
            btnLoading: false,
            formData: {},
            cycle: "",
            timePickerOption: { steps: [1, 15] },
            disabledMinutes:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,16,17,18,19,20,21,22,23,24,25,26,27,28,29,31,32,33,34,35,36,37,38,39,40,41,42,43,44,46,47,48,49,50,51,52,53,54,55,56,57,58,59],
            cyclerequired: false,
            ruleTime: "",
            standBookTotal: 0,
            ruleListTotal: 0,
            RuleTitle: "新增规则",
            ruleListParams: {
                page: 1,
                limit: 10,
                oilSiteId: "",
            }, // 自动台账列表
            standBookParams: {
                page: 1,
                limit: 10,
                oilSiteId: "",
            },
            dataLists: [], // 润滑点台账列表
            automaticRuleList: [], // 自动规则列表
            addRuleFormData: {
                oilSiteId: "",
                cycleType: null,
                timePoint: [],
                startTime: "",
                endTime: "",
                cycle: "",
                statu: null,
                describeRule: "",
            },
            accountFromData: {
                oilSiteId: "",
                statu: null,
                startTime: "",
                endTime: "",
                describeRule: "",
            },
            accountFormValidate: {
                time: "",
                statu: null,
            },
            accuntRuleValidate: {
                time: [
                    {
                        required: true,
                        type: "array",
                        message: "请选择时间",
                        trigger: "change",
                    },
                ],
                statu: [
                    {
                        required: true,
                        type: "date",
                        message: "请选择状态",
                        trigger: "change",
                    },
                ],
            },
            RuleFormValidate: {
                cycle: "",
                ruleTime: "",
                statu: null,
            },
            RuleValidate: {
                cycle: [
                    {
                        required: true,
                        message: "请选择周期",
                    },
                ],
                ruleTime: [
                    {
                        required: true,
                        type: "array",
                        message: "请选择时间",
                        trigger: "change",
                    },
                ],
                statu: [
                    {
                        required: true,
                        message: "请选择状态",
                    },
                ],
            },
            status: [], // 状态
            cycles: [], // 接口的周期
            dataColumn: [
                {
                    title: "台账类型",
                    key: "isAutoAccount",
                    width: 150,
                    align: "left",
                    // fixed: "left",
                    render: (h, params) => {
                        const item = params.row;
                        return h(
                            "div",
                            (item.isAutoAccount == 0
                                ? "手动台账"
                                : "自动台账") || "-"
                        );
                    },
                },
                {
                    title: "开始时间",
                    type: "ruleStatuStartTime",
                    align: "left",
                    //   width: 80,

                    //   fixed: "left",
                    render: (h, params) => {
                        const item = params.row;
                        return h("div", item.ruleStatuStartTime || "-");
                    },
                },
                {
                    title: "结束时间",
                    key: "ruleStatuEndTime",
                    align: "left",
                    //   width: 200,
                    //   fixed: "left",
                    render: (h, params) => {
                        const item = params.row;
                        return h("div", item.ruleStatuEndTime || "-");
                    },
                },
                {
                    title: "状态",
                    key: "statu",
                    align: "left",
                    //   width: 220,
                    render: (h, params) => {
                        const item = params.row;
                        return h("div", item.statu || "-");
                    },
                },
                // {
                //     title: "描述",
                //     key: "describeRule",
                //     align: "left",
                //     // width: 150,
                //     render: (h, params) => {
                //         const item = params.row;
                //         //   return h("div", item.describeRule || "-");
                //         return h(
                //             "Tooltip",
                //             {
                //                 props: {
                //                     maxWidth: 200,
                //                     placement: "top",
                //                     name: "true",
                //                     content: item.describeRule || "-",
                //                     theme: "light",
                //                     transfer: true,
                //                 },
                //             },
                //             [
                //                 h(
                //                     "div",
                //                     {
                //                         style: {
                //                             width: "190px",
                //                             overflow: "hidden",
                //                             "word-break": "break-all",
                //                             "text-overflow": "ellipsis",
                //                             "-webkit-line-clamp": 2,
                //                             "text-overflow":
                //                                 "-o-ellipsis-lastline",
                //                             "line-clamp": 2,
                //                             "-webkit-box-orient": "vertical",
                //                             display: "-webkit-box !important",
                //                         },
                //                     },
                //                     item.describeRule || "-"
                //                 ),
                //             ]
                //         );
                //     },
                // },
                {
              title: "描述",
              key: "describeRule",
              width: 220,
                align: "left",
              render: (h, params) => {
                const item = params.row;
                return h("Tooltip", {
                    props: {
                        
                      maxWidth: 210,
                      placement: 'top',
                      name: 'true',
                      content: item.describeRule || "-",
                      theme: "light",
                      transfer: true
                    },
                  },
                  [
                    h('div', {
                      style: {
                        "width": "210px",
                        "overflow": "hidden",
                        "word-break": "break-all",
                        "text-overflow": "ellipsis",
                        "-webkit-line-clamp": 2,
                        "text-overflow": "-o-ellipsis-lastline",
                        'line-clamp': 2,
                        "-webkit-box-orient": "vertical",
                        "display": "-webkit-box !important",
                        "position": "relative",
                        // "left": "-18px"
  
                      }
                    },  item.describeRule || "-")
                  ]
                );
              },
            },
                {
                    title: "记录人",
                    key: "operatorName",
                    align: "left",
                    //   width: 150,
                    render: (h, params) => {
                        const item = params.row;
                        return h("div", item.operatorName || "-");
                    },
                },
                {
                    title: "创建时间",
                    key: "gmtCreate",
                    align: "left",
                    //   width: 150,
                    render: (h, params) => {
                        const item = params.row;
                        return h("div", item.gmtCreate || "-");
                    },
                },
                {
                    title: "操作",
                    key: "address",
                    align: "left",

                    //   fixed: "right",
                    width: 130,
                    className: "action",
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "span",
                                {
                                    props: {
                                        size: "small",
                                    },
                                    style: {
                                        color: "#0c479d", //"#ed4014"
                                        cursor: "pointer",
                                    },
                                    on: {
                                        click: () => {
                                            this.delItemWarning(params.row);
                                        },
                                    },
                                },
                                "删除"
                            ),
                        ]);
                    },
                },
            ],
            ruleList: [
                {
                    title: "周期",
                    key: "timePoint",
                    width: 150,
                    align: "left",
                    //   fixed: "left",
                    render: (h, params) => {
                        const item = params.row;
                   
                        let text = "";
                        if (item.cycleType == 1) {
                            text = "每周";
                        } else if (item.cycleType == 2) {
                            text = "每月";
                        }
                        return h("div", text + item.timePoint || "-");
                    },
                },
                {
                    title: "开始时间",
                    key: "startTime",
                    width: 100,
                    align: "left",
                    //   fixed: "left",
                    render: (h, params) => {
                        const item = params.row;
                        return h("div", item.startTime || "-");
                    },
                },
                {
                    title: "结束时间",
                    key: "endTime",
                    width: 100,
                    align: "left",
                    //   fixed: "left",
                    render: (h, params) => {
                        const item = params.row;
                        return h("div", item.endTime || "-");
                    },
                },
                {
                    title: "标记",
                    key: "statu",
                    width: 100,
                    align: "left",
                    //   fixed: "left",
                    render: (h, params) => {
                        const item = params.row;
                        return h("div", item.statu || "-");
                    },
                },
                {
                    title: "备注",
                    key: "describeRule",
                    width: 200,
                    align: "left",

                    // render: (h, params) => {
                    //     const item = params.row;
                    //     return h("div", item.describeRule || "-");
                    // },
                    render: (h, params) => {
                        const item = params.row;

                        return h(
                            "Tooltip",
                            {
                                props: {
                                    maxWidth: 200,
                                    placement: "top",
                                    name: "true",
                                    content: item.describeRule || "-",
                                    theme: "light",
                                    transfer: true,
                                },
                            },
                            [
                                h(
                                    "div",
                                    {
                                        style: {
                                            width: "190px",
                                            overflow: "hidden",
                                            "word-break": "break-all",
                                            "text-overflow": "ellipsis",
                                            "-webkit-line-clamp": 2,
                                            "text-overflow":
                                                "-o-ellipsis-lastline",
                                            "line-clamp": 2,
                                            "-webkit-box-orient": "vertical",
                                            display: "-webkit-box !important",
                                            position: "relative",
                                            left: "-18px",
                                        },
                                    },
                                    item.describeRule || "-"
                                ),
                            ]
                        );
                    },
                },
                {
                    title: "创建人",
                    key: "operatorName",
                    width: 100,
                    align: "left",
                    //   fixed: "left",
                    render: (h, params) => {
                        const item = params.row;
                        return h("div", item.operatorName || "-");
                    },
                },
                {
                    title: "创建时间",
                    key: "gmtCreate",
                    width: 200,
                    align: "left",
                    //   fixed: "left",
                    render: (h, params) => {
                        const item = params.row;
                        return h("div", item.gmtCreate || "-");
                    },
                },
                {
                    title: "操作",
                    key: "address",
                    align: "left",
                    fixed: "right",
                    width: 130,
                    className: "action",
                    render: (h, params) => {
                        // const showIt = this.userRole.indexOf("m1") > -1;
                        return h("div", [
                            h(
                                "span",
                                {
                                    props: {
                                        size: "small",
                                    },
                                    style: {
                                        color: "#0c479d", //"#e9aa69",
                                        cursor: "pointer",
                                    },
                                    on: {
                                        click: () => {
                                            this.editRuleDetail(params.row);
                                        },
                                    },
                                },
                                "编辑"
                            ),
                            h(
                                "span",
                                {
                                    style: {
                                        // display: showIt
                                        //     ? "inline-block"
                                        //     : "none",
                                        color: "#ddd",
                                        margin: "0 10px",
                                        verticalAlign: "middle",
                                    },
                                },
                                "|"
                            ),
                            h(
                                "span",
                                {
                                    props: {
                                        size: "small",
                                    },
                                    style: {
                                        color: "#0c479d", //"#ed4014"
                                        cursor: "pointer",
                                        // display: showIt
                                        //     ? "inline-block"
                                        //     : "none",
                                    },
                                    on: {
                                        click: () => {
                                            this.delItemRule(params.row);
                                        },
                                    },
                                },
                                "删除"
                            ),
                        ]);
                    },
                },
            ],
        };
    },
    mounted() {
        this.cycleData();
        // this.statusData();
        this.getStandBookList();
        // 权限
        this.userRole = this.userInfo.authority;
        const role = this.toRoleName(this.userRole);
        if (this.userRole) ls.set("userRole", role);

        // 可删除 美孚员工，美孚管理员，客户管理员
        if (!(["m0", "m1", "c1"].indexOf(this.userRole) > -1)) {
            this.dataColumn = this.dataColumn.filter(
                (col) => col.title !== "操作"
            );
        }
    },
    methods: {
        async getStandBookList(page) {
            this.isdisble = false;
            if (page) this.standBookParams.page = page; //分页处理
            // 获取台账列表
            this.standBookParams.oilSiteId = this.$route.params.id;
            let accountstatu =await api.axss("get", "/ocm-oil-site/oil-account/statu")
             const datas = accountstatu.data
             this.status = datas;

            // .then((res) => {
            //     if (res.code === "00000") {
            //         const datas = res.data || {};
            //         this.status = datas;
            //     }
            // });
            this.$nextTick( async ()=>{
            let res = await api.axss(
                "post",
                "/ocm-oil-site/oil-account/oilSite/page/info",
                this.standBookParams
            );
            this.isdisble = true;

            if (res.code === "00000") {
                if(this.groupAuthorityString=="r"){
                  let findIndex=this.ruleList.findIndex(e=>e.title=="操作")
                  this.ruleList.splice(findIndex,1)
                  
                   let dataIndex=this.dataColumn.findIndex(e=>e.title=="操作")
                   this.dataColumn.splice(dataIndex,1)
             }
                let arr = res.data.records;
                arr.forEach((item) => {
                    item.startTime = item.oilSiteAccountRuleDTO.startTime;
                    item.endTime = item.oilSiteAccountRuleDTO.endTime;
                    item.describeRule = item.oilSiteAccountRuleDTO.describeRule;
                    item.operatorName = item.oilSiteAccountRuleDTO.operatorName;
                    this.status.forEach((subitem) => {
                        if (
                            item.oilSiteAccountRuleDTO.statu == subitem.number
                        ) {
                            item.statu = subitem.describe;
                        }
                    });
                });
                this.dataLists = arr;
                this.standBookTotal = res.data.total;
            }
            })
        },
        getStandListsSize(size) {
            this.standBookParams.limit = size;
            this.getStandBookList(1);
        },
        cycleData() {
            // 获取周期
            api.axss("get", "/ocm-oil-site/oil-account/cycle").then((res) => {
                if (res.code === "00000") {
                    const datas = res.data || {};
                    datas.forEach((item) => {
                        if (item.statusList) {
                            item.statusList.forEach((subitem) => {
                                subitem.active = 0;
                            });
                        }
                    });
                    this.cycles = datas;
                }
            });
        },
        statusData() {
            // 获取状态
            api.axss("get", "/ocm-oil-site/oil-account/statu").then((res) => {
                if (res.code === "00000") {
                    const datas = res.data || {};
                    this.status = datas;
                }
            });
        },
        accountClick() {
            // 点击"手动录入台账" 按钮
            // 显示弹窗
            this.enterIsshow = true;
        },
        submitAccuntForm() {
            // 手动录入台账提交
            this.accountFromData.oilSiteId = this.$route.params.id;
            this.$refs.accountFormValidate.validate((valid) => {
                if (valid) {
                    delete this.accountFromData.time;
                    api.axss(
                        "post",
                        "/ocm-oil-site/oil-account/add/manual",
                        this.accountFromData
                    ).then((res) => {
                        if (res.code === "00000") {
                            this.$Message.success("录入成功");
                            this.enterIsshow = false;
                            this.getStandBookList(1);
                            this.getLists();
                        }
                    });
                } else {
                    this.$Message.error("Fail");
                }
            });
        },
        submitRuleForm() {
       
            this.addRuleFormData.timePoint.length == 0 &&this.addRuleFormData.cycleType !=0
            
                ? (this.cyclerequired = true)
                : (this.cyclerequired = false);
            this.$refs.RuleFormValidate.validate((valid) => {
                if (valid) {
                    // delete this.addRuleFormData.cycle;
                    // delete this.addRuleFormData.ruleTime;
                    // 新增规则提交
                    this.addRuleFormData.oilSiteId = this.$route.params.id;
                    this.addRuleFormData.timePoint =
                        this.addRuleFormData.timePoint.join(",");
                   
                    // return false;
                    this.btnLoading = true;
                    if (this.RuleTitle == "新增规则") {
                        api.axss(
                            "post",
                            "/ocm-oil-site/oil-account/add/rule",
                            this.addRuleFormData
                        )
                            .then((res) => {
                                  this.btnLoading = false;
                                if (res.code === "00000") {
                                  
                                    this.addRuleIsshow = false;
                                    this.$Message.success("新增规则成功");
                                    const finalSize = this.sizeData(
                                        this.ruleListParams.limit,
                                        this.ruleListParams.page,
                                        this.ruleListTotal
                                    );
                                    this.getRuleList(finalSize);
                                }
                            })
                            .catch((error) => {
                                this.btnLoading = false;
                            });
                    } else {
                        // 编辑
                        api.axss(
                            "post",
                            "/ocm-oil-site/oil-account/edit/rule",
                            this.addRuleFormData
                        )
                            .then((res) => {
                                if (res.code === "00000") {
                                    this.btnLoading = false;
                                    this.addRuleIsshow = false;
                                    this.$Message.success("编辑规则成功");
                                    const finalSize = this.sizeData(
                                        this.ruleListParams.limit,
                                        this.ruleListParams.page,
                                        this.ruleListTotal
                                    );
                                    this.getRuleList(finalSize);
                                }
                            })
                            .catch((error) => {
                                this.btnLoading = false;
                            });
                    }
                } else {
                    
                }
            });
        },
        changeDate(date, name) {
         
            // 手动录入台账的时间
            this.accountFromData.startTime = date[0];
            this.accountFromData.endTime = date[1];
        },
        ruleChangeDate(date, name) {
            // 新增规则的时间
            this.addRuleFormData.startTime = date[0];
            this.addRuleFormData.endTime = date[1];
        },
        option(value) {
            this.cycleChanges = false;
            if (this.addRuleFormData.cycleType != value.number) {
                this.addRuleFormData.cycle = "";
                this.addRuleFormData.timePoint = [];
                this.cycles[1].statusList.forEach((item) => {
                    item.active = 0;
                });
                this.cycles[2].statusList.forEach((item) => {
                    item.active = 0;
                });
            }
            if (value.describe == "每周") {
                this.changeCycle = "week";
            } else if (value.describe == "每月") {
                this.changeCycle = "month";
            } else {
                this.changeCycle = "day";
                this.addRuleFormData.cycle = value.describe;
                this.cyclerequired = false;
            }
            this.cycles.forEach((item) => {
                if (item.describe == value.describe) {
                    this.addRuleFormData.cycleType = item.number;
                }
            });
        },
        cycleDetailClick(item) {
            this.cyclerequired = false;

            // 周期详细点击
            if (item.active == 1) {
                item.active = 0;
                let index = this.addRuleFormData.timePoint.indexOf(item.number);
                if (index != -1) {
                    this.addRuleFormData.timePoint.splice(index, 1);
                    if (this.addRuleFormData.cycleType == 1) {
                        let arr = [];
                        this.addRuleFormData.timePoint.forEach((item) => {
                            this.cycles[1].statusList.forEach((subitem) => {
                                if (item == subitem.number) {
                                  
                                    arr.push(subitem.describe);
                                }
                            });
                        });
                        this.addRuleFormData.cycle = arr.join(",");
                    } else {
                        this.addRuleFormData.cycle =
                            this.addRuleFormData.timePoint.join(",");
                    }
                }

                let arr = this.addRuleFormData.cycle.split(",");
                let cycleIndex = arr.indexOf(item.describe);
                arr.splice(cycleIndex, 1);
            
                if (cycleIndex != -1) {
                   
                    this.addRuleFormData.cycle = arr.join(",");
                }
                
            } else {
                item.active = 1;
                this.addRuleFormData.timePoint.push(item.number);
                if (this.addRuleFormData.cycle) {
                    this.$set(
                        this.addRuleFormData,
                        "cycle",
                        this.addRuleFormData.cycle + "," + item.describe
                    );
                } else {
                    this.$set(this.addRuleFormData, "cycle", item.describe);
                }
            }
        },
        cycleOpenChange(e) {
            // this.cycleChanges = !this.cycleChanges;
            if (!e) {
                if (this.cycle == "每周") {
                    this.changeCycle = "week";
                    
                } else if (this.cycle == "每月") {
                    this.changeCycle = "month";
                }
            } else {
                this.cycleChanges = true;
            }
        },
        cycleClick(value) {
           
        },
        closeDrawer(value) {
            // 关闭弹窗
            // 每个弹窗传不同的title，判断后关闭
            if (value == "accountFrom") {
                this.enterIsshow = false;
                this.$refs.accountFormValidate.resetFields();
            } else {
                this.addRuleIsshow = false;
                this.$refs.RuleFormValidate.resetFields();
            }
        },
        closeaccount() {
            this.$refs.accountFormValidate.resetFields();
            this.$refs.RuleFormValidate.resetFields();
            this.accountFromData = {};
            this.cyclerequired = false;
            this.cycleChanges = false;
            this.changeCycle = "";
        },
        ruleClick() {
            // 获取自动规则列表
            this.ruleIsshow = true;
            this.getRuleList(1);
        },
        getRuleList(page) {
            this.ruleListParams.oilSiteId = this.$route.params.id;
            if (page) this.ruleListParams.page = page; //分页处理
            api.axss(
                "post",
                "/ocm-oil-site/oil-account/manual/rule",
                this.ruleListParams
            ).then((res) => {
                if (res.code === "00000") {
                    let arr = res.data.records;
                    arr.forEach((item) => {
                        this.status.forEach((subitem) => {
                            if (item.statu == subitem.number) {
                                item.statu = subitem.describe;
                            }
                            if (item.timePoint == "") {
                                item.timePoint = "每天";
                            }
                        });
                    });
                    this.automaticRuleList = arr;
                    this.ruleListTotal = res.data.total;
                }
            });
        },
        getRuleListsSize(size) {
            this.ruleListParams.limit = size;
            this.getRuleList(1);
        },
        delItemRule(row) {
            this.$Modal.confirm({
                title: `您确定要删除该规则？`,
                // content:`台账名称：${row.transducerName}`,
                onOk: () => {
                    this.delItem(row);
                },
                onCancel: () => {},
            });
        },
        delItem(row) {
            // 删除自动规则
            api.axss(
                "get",
                `/ocm-oil-site/oil-account/del/rule?ruleId=${row.id}`
            ).then((res) => {
                if (res.code === "00000") {
                    this.$Message.success("删除成功");
                    this.curItemDetail = {};
                    const finalSize = this.sizeData(
                        this.ruleListParams.limit,
                        this.ruleListParams.page,
                        this.ruleListTotal
                    );
                    this.getRuleList(finalSize);
                }
            });
        },
        delItemWarning(row) {
            // 删除台账
            this.$Modal.confirm({
                title: `您确定要删除该台账？`,
                // content:`台账名称：${row.transducerName}`,
                onOk: () => {
                    this.delStandItem(row);
                },
                onCancel: () => {},
            });
        },
        delStandItem(row) {
            // 台账列表某项删除
            let obj = {
                manualId: row.id,
                cycleType: row.oilSiteAccountRuleDTO.cycleType,
                ruleId: row.ruleId,
            };
            api.axss("post", "/ocm-oil-site/oil-account/del/manul", obj).then(
                (res) => {
                    if (res.code === "00000") {
                        this.$Message.success("删除成功");
                        this.curItemDetail = {};
                        const finalSize = this.sizeData(
                            this.standBookParams.limit,
                            this.standBookParams.page,
                            this.standBookTotal
                        );
                        this.getStandBookList(finalSize);
                        this.getLists();
                    }
                }
            );
        },
        addRuleClick() {
            // 点击新增规则按钮
            this.addRuleIsshow = true;
            this.RuleTitle = "新增规则";
            this.ruleTime = "";
            this.cycle = "";
            this.addRuleFormData = {
                oilSiteId: "",
                cycleType: null,
                timePoint: [],
                startTime: "",
                endTime: "",
                statu: null,
                describeRule: "",
            };
        },
        editRuleDetail(item) {
          
            //编辑自动规则
            this.addRuleIsshow = true;
            this.RuleTitle = "编辑规则";
            let date = [];
            // 周期
            if (item.cycleType == 0) {
                this.cycle = "每天";
            } else if (item.cycleType == 1) {
                this.cycle = item.timePoint;
            
                // 具体日期
                let dateArr = [];
                dateArr = item.timePoint.replace(/\s+/g, "").split(",");
                this.cycles[1].statusList.map((sitem) => {
                    let index = dateArr.indexOf(sitem.describe);
                    if (index != -1) {
                        sitem.active = 1;
                        date.push(sitem.number);
                    }
                });
            } else {
                var reg = new RegExp("号", "g");
                date = item.timePoint
                    .replace(/\s+/g, "")
                    .replace(reg, "")
                    .split(",");
                this.cycle = date.join(",");
                
                this.cycles[2].statusList.map((sitem) => {
                    let index = date.indexOf(sitem.describe);
                    if (index != -1) {
                        sitem.active = 1;
                    }
                });
                date = date.map(Number);
            }
            // 状态
            let statu;
            this.status.forEach((statuItem) => {
                if (statuItem.describe == item.statu) {
                    statu = statuItem.number;
                }
            });
            // 时间
            (this.ruleTime = [item.startTime, item.endTime]),
                (this.addRuleFormData = {
                    oilSiteId: this.$route.params.id,
                    cycleType: item.cycleType,
                    timePoint: date,
                    startTime: item.startTime,
                    endTime: item.endTime,
                    statu: statu,
                    describeRule: item.describeRule,
                    id: item.id,
                    ruleTime: this.ruleTime,
                    cycle: this.cycle,
                });
         
        },
    },
};
</script>
  <style>  
 .standBook  .dataExportDrawer .ivu-btn.ivu-btn-primary {
    color: #fff !important;
    background-color: #0c479d !important;
    border-color: #0c479d !important;
    padding: 0 7px !important;
   
}

.constabook .ivu-btn-primary {
    color: #fff;
    background-color: #0c479d;
    border-color: #0c479d;
}
.constabook .ivu-btn-small {
}
.constabook .ivu-btn-small {
    padding: 0 7px !important;
}
</style>
  
  <style lang="less" scoped>
.standBook {
    margin: 20px 0px;
}
.option {
    .item {
        height: 30px;
        line-height: 30px;
    }
}
.star {
    display: inline-block;
    color: red;
    margin-right: 4px;
    margin-bottom: 8px;
}
.cycle {
    position: relative;
    .errorTip {
        position: absolute;
        top: 100%;
        left: 0;
        line-height: 1;
        padding-top: 6px;
        color: #ed4014;
    }
}

.select {
    border-radius: 4px;
    border: 1px solid #dcdee2;
    height: 32px;
    color: #515a6e;
    position: relative;
    .pla {
        display: block;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-left: 8px;
        padding-right: 24px;
    }
    .icon {
        display: inline-block;
        position: absolute;
        top: 8px;
        right: -8px;
        font-size: 14px;
        color: #808695;
        -webkit-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;
    }
    .gray {
        color: #c5c8ce;
    }
}
.borderRed {
    border: 1px solid red;
}
.selection {
    border-color: #3d6cb1;
    outline: 0;
    -webkit-box-shadow: 0 0 0 2px rgba(12, 71, 157, 0.2);
    box-shadow: 0 0 0 2px rgba(12, 71, 157, 0.2);
}
.option {
    position: relative;
    z-index: 99999999999;
    // width: 448px;
    width:100%;
    padding: 5px 0px;
    border: 1px solid #dcdee2;
    border-top: 0px;
    .item {
        cursor: pointer;
        padding-left: 14px;
    }
    .item:hover {
        background: #f3f3f3;
        cursor: pointer;
    }
}
.time {
    // width: 448px;
    width: 100%;
    padding: 16px 14px;
    border: 1px solid #dcdee2;
    border-top: 0px;
    display: flex;
    flex-wrap: wrap;

    span {
        display: inline-block;
        font-size: 14px;
        font-weight: 400;
        color: #373d41;
    }

    .active {
        background: #3d6cb1;
        color: white;
    }
}

.cycleDetail {
    justify-content: space-between;

    span {
        padding: 0px 6px;
    }

    .words {
        flex: 0 0 13%;
    }
}

.cycleDetails {
    padding: 16px 14px 6px 14px;

    span {
        width: 24px;
        height: 24px;
        text-align: center;
        line-height: 24px;

        &:nth-child(7n) {
            margin-right: 0;
        }
    }

    .words {
        margin-right: 41px;
        margin-bottom: 10px;
    }
}

.ivu-drawer-wrap {
    z-index: 99999;
}
</style>
  